export const EnrollmentType = Object.freeze({
    "Unknown": 0,
    "NewHire": 1,
    "LifeEvent": 2,
    "OpenEnrollment": 3,
    "BenficiaryChange": 4
})